import {
  CARAT_DATA,
  GOLD_DATA,
  GRAM_WISE_CARAT_RATE,
  GRAM_WISE_SINGLE_CARAT_DATA,
  SILVER_DATA,
} from './types';

export const capitalized = (word: string): string =>
  word.charAt(0).toUpperCase() + word.slice(1);

export enum SIGN {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  ZERO = 'zero',
}
export const checkNumberSign = (value: number): string => {
  if (value > 0) return SIGN.POSITIVE;
  if (value < 0) return SIGN.NEGATIVE;
  return SIGN.ZERO;
};

export const getGramWiseGoldData = (
  data: GOLD_DATA
): GRAM_WISE_CARAT_RATE[] => {
  return [
    {
      carat: '24 carat',
      rate: data.carat24.ratePerGram,
      change: data.carat24.change,
    },
    {
      carat: '22 carat',
      rate: data.carat22.ratePerGram,
      change: data.carat22.change,
    },
    {
      carat: '18 carat',
      rate: data.carat18.ratePerGram,
      change: data.carat18.change,
    },
    {
      carat: '14 carat',
      rate: data.carat14.ratePerGram,
      change: data.carat14.change,
    },
    {
      carat: '12 carat',
      rate: data.carat12.ratePerGram,
      change: data.carat12.change,
    },
    {
      carat: '9 carat',
      rate: data.carat9.ratePerGram,
      change: data.carat9.change,
    },
  ];
};

const GRAM_WEIGHTS = [
  { weight: '1 g', multiplier: 1 },
  { weight: '8 g', multiplier: 8 },
  { weight: '10 g', multiplier: 10 },
  { weight: '100 g', multiplier: 100 },
  { weight: '250 g', multiplier: 250 },
  { weight: '500 g', multiplier: 500 },
  { weight: '1 kg', multiplier: 1000 },
];

const buildGramWiseData = (
  ratePerGram: number,
  change: number
): GRAM_WISE_SINGLE_CARAT_DATA[] => {
  return GRAM_WEIGHTS.map(({ weight, multiplier }) => ({
    weight,
    rate: Math.floor(ratePerGram * multiplier),
    change: Math.floor(change * multiplier),
  }));
};

export const getGramWiseGoldCaratData = (
  data: GOLD_DATA,
  carat: string
): GRAM_WISE_SINGLE_CARAT_DATA[] => {
  switch (carat) {
    case '24k':
      return buildGramWiseData(data.carat24.ratePerGram, data.carat24.change);
    case '22k':
      return buildGramWiseData(data.carat22.ratePerGram, data.carat22.change);
    case '18k':
      return buildGramWiseData(data.carat18.ratePerGram, data.carat18.change);
    case '14k':
      return buildGramWiseData(data.carat14.ratePerGram, data.carat14.change);
    case '12k':
      return buildGramWiseData(data.carat12.ratePerGram, data.carat12.change);
    case '9k':
      return buildGramWiseData(data.carat9.ratePerGram, data.carat9.change);
    default:
      return buildGramWiseData(data.carat24.ratePerGram, data.carat24.change);
  }
};

export const getGramWiseSilverData = (data: SILVER_DATA): CARAT_DATA[] => {
  return [
    {
      ratePerGram: data.ratePerGram,
      change: data.change,
    },
  ];
};

export const replaceCMSDate = (text: string, currentDate: string): string => {
  if (!text) return text;
  return text.replace(/\{date\}/g, currentDate);
};

export const getMetalData = async (URLArrays: Array<string>) => {
  const array = await Promise.all(URLArrays.map((url) => fetch(url)));
  return await Promise.all(array.map((res) => res.json()));
};
